package music.jammers.shared.event.domain.model

import kotlinx.datetime.LocalDateTime
import kotlinx.serialization.Serializable

@Serializable
data class Event(
    val id: Long,
    val title: String,
    val description: String,
    val date: LocalDateTime,
    val genre: String,
    val spot: String,
    val songsLimit: Int,
    val appliesPerPerson: Int,
    val eventInstruments: List<EventInstrument>,
    val cardInfo: CardInfo,
    val readyTracks: Int,
    val tracksCount: Int,
)